/*
自动生成代码，请不要手工修改
create at 2025&#x2F;6&#x2F;19 09:39:24
*/

export interface SendSmsToDept {
  content: string;

  deptIds?: string[];
}

export interface UpdatePrintTagDto {
  /**
   * 培训班Id
   */
  id: string;
  /**
   * 培训班类型
   */
  classType: TrainingClassType;
}

// tslint:disable-next-line:no-empty-interface
export enum TrainingClassType {
  干教调训班 = 0,
  单位自主计划培训班 = 1,
  其他 = 2,
  中组部调训班 = 3,
}

export interface UploadStudentManualDto {
  /**
   * 培训班Id
   */
  id: string;
  /**
   * 学员手册附件Key
   */
  attachmentKey: string;
  /**
   * 培训班类型
   */
  classType: TrainingClassType;
}

export interface CourseEvaluationDto {
  /**
   * 培训班Id
   */
  id: string;
  /**
   * 课程评价开关
   */
  value: boolean;
  /**
   * 培训班类型
   */
  classType: TrainingClassType;
}

export interface IDModel {
  id: string;
}

export interface StorageTrainingSchedule {
  /**
   * 培训班id
   */
  classId: string;
  /**
   * 日程信息
   */
  trainingSchedules?: TrainingScheduleDto[];
}

export interface TrainingScheduleDto {
  id?: string;

  systemTeacherId?: string;

  trainingDate: string;

  trainingTime?: string;

  trainingStartTime?: string;

  trainingEndTime?: string;

  courseName?: string;

  courseForm: CourseForm;

  teacher?: string;

  phone?: string;

  teacherIdCard?: string;

  teacherJob?: string;

  unitName?: string;

  address?: string;

  placeType?: string;

  hours: number;
}

// tslint:disable-next-line:no-empty-interface
export enum CourseForm {
  分组研讨 = 0,
  网络培训 = 1,
  专题授课 = 2,
  现场教学 = 3,
  其他 = 4,
}

// tslint:disable-next-line:no-empty-interface
export enum SelfTrainPlanAuditStatus {
  未提交 = 0,
  待审核 = 1,
  已审核通过 = 2,
  未审核通过 = 3,
  待修改 = 4,
  已取消 = 5,
}

// tslint:disable-next-line:no-empty-interface
export enum SelfPlanType {
  培训班 = 0,
  案例工作 = 1,
  网络学习 = 2,
  行动学习 = 3,
}

export interface BatchAuditDeleteApplyDto {
  /**
   * 一键审核申请删除的单位
   */
  deptId: string;
  /**
   * 删除审核意见
   */
  deleteAuditOpinion?: string;
  /**
   * 删除审核状态
   */
  deleteAuditStatus: DeleteAuditStatus;
}

// tslint:disable-next-line:no-empty-interface
export enum DeleteAuditStatus {
  待审核 = 0,
  已通过 = 1,
  未通过 = 2,
}

export interface ResetPasswordDto {
  userId: string;
  /**
   * 新密码
   */
  newPassword: string;
}

export interface UserOnlineCountHours {
  hours: number;

  userId?: string;
}

export interface UserOnlineCourseDetails {
  total: number;

  rows?: UserOnlineCourse[];
}

export interface UserOnlineCourse extends UserOnlineCountHours {
  courseName?: string;

  entityType: HoursType;

  gainDate: string;
}

// tslint:disable-next-line:no-empty-interface
export enum HoursType {
  自选课学时 = 1,
  培训班课程学时 = 2,
  考试学时 = 3,
  线下登记学时 = 4,
}

export interface PersonalTrainSummary {
  /**
   * 实际培训天数
   */
  actualTrainDays: number;
  /**
   * 线上学习学时
   */
  onlineTrainHours: number;
  /**
   * 培训要求天数：科级及以下五年60天 ,处级及以上90天。
   */
  shouldTrainDays: number;
}

export interface PlatformValidateCode {
  phone: string;

  verCode: string;
}

// tslint:disable-next-line:no-empty-interface
export enum SmsType {
  登录验证 = 1,
  修改手机号 = 2,
}

export interface WeixinLoginReslut {
  avatar?: string;

  company?: string;

  createDate?: string;

  email?: string;

  phone?: string;

  sex?: number;

  userExtends?: UserExtends;

  userId?: string;

  userName?: string;

  userRank?: string;

  userType?: string;

  userType1?: string;

  userType2?: string;

  workUnit?: string;

  accesstoken?: string;

  wxOpenId?: string;

  authKeyValid: boolean;
}

export interface UserExtends {
  cellphone?: string;

  birthday?: string;

  education?: string;

  educationName?: string;

  entryTime?: string;

  name?: string;

  nation?: string;

  nationName?: string;

  photo?: string;

  rank?: string;

  remarks?: string;

  school?: string;

  specialty?: string;

  title?: string;

  userId: number;
}

export interface LoginResult extends ApiResponseData<any> {
  /**
   * 网院返回信息
   */
  wyData?: WeixinLoginReslut;
  /**
   * OpenId
   */
  openId?: string;
  /**
   * 签名数据
   */
  signature?: string;
}

export interface StudentInfoDto {
  id: string;

  deptId?: string;

  imageName?: string;

  name: string;

  birthday?: string;

  job?: string;

  workUnit?: string;

  city?: string;

  postRank?: number;

  unManageRank?: number;

  nation?: string;

  sex?: string;

  type?: UserType;
}

// tslint:disable-next-line:no-empty-interface
export enum UserType {
  普通用户 = 0,
  单位管理员 = 1,
  系统管理员 = 2,
  请假审核员 = 3,
}

export interface LeaveAuditorDto {
  id: string;

  classType: TrainingClassType;

  leaveAuditorId: string;

  leaveAuditorName: string;

  leaveAuditorPhone: string;

  leaveAuditorId2?: string;

  leaveAuditorName2?: string;

  leaveAuditorPhone2?: string;
}

export interface BatchDeleteIdsModel {
  ids?: string[];
}

export interface EditTrainClassDto {
  id: string;

  classType: TrainingClassType;

  startClassDate: string;

  endClassDate: string;

  days: number;

  address?: string;

  trainingAgency?: string;

  leaveAuditorId: string;

  leaveAuditorName: string;

  leaveAuditorPhone: string;

  leaveAuditorId2?: string;

  leaveAuditorName2?: string;

  leaveAuditorPhone2?: string;
}

export interface DeptPlanClassDto {
  id?: string;

  selfTrainPlanId: string;

  className: string;

  startClassDate: string;

  endClassDate: string;

  days: number;

  number: number;

  trainType?: string;

  locationCategory?: string;

  liaison?: string;

  liaisonPhone?: string;

  address?: string;

  trainingAgency?: string;

  remark?: string;
}

// tslint:disable-next-line:no-empty-interface
export enum CommonAuditStatus {
  待审核 = 0,
  已通过 = 1,
  未通过 = 2,
  未提交 = 3,
}

export interface BatchAduitDto {
  ids?: string[];

  auditState: CommonAuditStatus;
  /**
   * 干教处审核时 需要设置是否做退学处理
   */
  isDropOut?: boolean;
  /**
   * 保留原因 (如果不做退学处理时保留学时的原因)
   */
  retainReason?: string;
  /**
   * 审核意见
   */
  auditOpinion?: string;
}

export interface SignUpDto {
  classId: string;
  /**
   * 培训班类型
   */
  classType: TrainingClassType;
}

export interface TrainClassDto {
  id: string;

  classType: TrainingClassType;

  createdOn: string;

  createdBy?: string;

  deptId: string;

  deptCode?: string;

  deptName?: string;

  className?: string;

  startDate: string;

  endDate: string;

  days: number;

  locationCategory?: string;

  liaison?: string;

  liaisonPhone?: string;

  address?: string;

  trainingAgency?: string;

  trainType?: string;

  runClassType?: string;

  content?: string;

  objectScope?: string;

  number: number;

  studentManualKey?: string;
}

// tslint:disable-next-line:no-empty-interface
export enum ClassState {
  未报道 = 1,
  培训中 = 2,
  已结束 = 3,
}

export interface ClassSolutionMobile {
  id: string;

  startSignUpDate: string;

  endSignUpDate: string;

  startSignInDate?: string;

  endSignInDate?: string;

  signInTimeinterval?: string;

  isMustAttendance?: boolean;

  isMustSubmitExperience?: boolean;
}

export interface ComperhensiveEvaluationDto {
  classType: TrainingClassType;

  trainingAgencyId?: string;

  trainingAgencyName?: string;

  className?: string;

  deptId: string;

  trainingAgencyStorage?: string;

  trainingAgencyDicValue?: object;

  organizerStorage?: string;

  organizerDicValue?: object;

  content?: string;

  score: number;

  level?: EvaluationLevel;

  sponsor?: string;

  id?: string;

  classId: string;
}

// tslint:disable-next-line:no-empty-interface
export enum EvaluationLevel {
  较差 = 1,
  差 = 2,
  一般 = 3,
  良好 = 4,
  优秀 = 5,
}

// tslint:disable-next-line:no-empty-interface
export enum PostRank {
  厅级 = 1,
  处级及以下 = 2,
}

export interface EditLeaveDto {
  id: string;

  startTime: string;

  startTimeSlot?: TimeSlot;

  endTime?: string;

  endTimeSlot?: TimeSlot;

  days: number;

  reason?: string;
}

// tslint:disable-next-line:no-empty-interface
export enum TimeSlot {
  上午 = 0,
  下午 = 1,
  晚上 = 2,
}

export interface IdsModel {
  ids?: string[];
}

export interface TrainingClassLeave extends BaseEntityOfGuid {
  isOrgLeave: boolean;

  classType?: TrainingClassType;

  publicTrainingClassId?: string;

  className?: string;

  deptId?: string;

  deptCode?: string;

  deptName?: string;

  traineeId?: string;

  studentName?: string;

  workUnit?: string;

  job?: string;

  postRank?: number;

  unManageRank?: number;

  startTime: string;

  startTimeSlot?: TimeSlot;

  endTime?: string;

  endTimeSlot?: TimeSlot;

  days: number;

  isDropOut: boolean;

  retainReason?: string;

  reason?: string;

  attachmentKey?: string;

  number: number;

  orgAuditStatus?: CommonAuditStatus;

  orgAuditOpinion?: string;

  orgAuditTime?: string;

  orgAuditorId?: string;

  orgAuditorUserName?: string;

  auditStatus?: CommonAuditStatus;

  auditOpinion?: string;

  auditTime?: string;

  auditorId?: string;

  auditorUserName?: string;
}

export interface BaseEntityOfGuid {
  id: string;

  createdBy?: string;

  createdOn: string;

  modifiedBy?: string;

  modifiedOn?: string;
}

export interface TrainingClassLeaveDto {
  isOrgLeave: boolean;

  classType?: TrainingClassType;

  publicTrainingClassId?: string;

  className: string;

  deptId: string;

  traineeId?: string;

  studentName?: string;

  workUnit?: string;

  job?: string;

  postRank?: number;

  unManageRank?: number;

  startTime: string;

  startTimeSlot?: TimeSlot;

  endTime?: string;

  endTimeSlot?: TimeSlot;

  days: number;

  isDropOut: boolean;

  retainReason?: string;

  reason?: string;

  attachmentKey: string;

  number: number;

  id?: string;

  phone?: string;
}

// tslint:disable-next-line:no-empty-interface
export enum ProblemImportance {
  一般 = 0,
  重要 = 1,
  非常重要 = 2,
}

export interface MarkProblemDto {
  id: string;

  isSolved: boolean;
}

export interface ReplyProblemDto {
  id: string;

  response?: string;
}

export interface ProblemDto extends ProblemBase {
  id?: string;
}

export interface ProblemBase {
  className?: string;

  classType?: TrainingClassType;

  publicTrainingClassId?: string;

  title?: string;

  category?: string;

  importance: ProblemImportance;

  content?: string;
}

export interface StudentRoomDto extends StudentRoomBase {
  id?: string;
}

export interface StudentRoomBase {
  classType?: TrainingClassType;

  publicTrainingClassId?: string;

  name: string;

  phone?: string;

  number: string;

  remark?: string;
}

export interface TeacherEvaluationDto {
  classType: TrainingClassType;

  publicTrainingClassId: string;

  className?: string;

  trainingSchedulingId: string;

  courseName?: string;

  teacherId?: string;

  teacherName?: string;

  deptId?: string;

  storage?: string;

  dicValue?: object;

  score: number;

  level?: EvaluationLevel;

  content?: string;

  id?: string;
}

export interface TrainingScheduling extends BaseTrainingSchedule {
  trainingDate: string;

  trainingTime?: string;

  teacherIdCard?: string;

  selfTrainPlanId?: string;

  openClassSolutionId?: string;
}

export interface BaseTrainingSchedule extends BaseEntityOfGuid {
  systemTeacherId?: string;

  trainingStartTime: string;

  trainingEndTime: string;

  courseForm: CourseForm;

  courseName?: string;

  teacher?: string;

  phone?: string;

  teacherJob?: string;

  unitName?: string;

  address?: string;

  placeType?: string;

  hours: number;
}

export interface IDModelString {
  id?: string;
}

export interface TraineeOpenId {
  id: string;

  traineeId: string;

  openId: string;

  name?: string;

  createTime: string;
}

export interface TrainingAgencyDto {
  name: string;

  order: number;

  address?: string;

  contacts?: string;

  phone?: string;

  description?: string;

  id?: string;
}

export interface ProvinceCadreDto {
  id?: string;
  /**
   * 学员主管单位
   */
  deptId?: string;
  /**
   * 姓名(必填项)
   */
  name: string;
  /**
   * 性别
   */
  sex: Sex;
  /**
   * 民族
   */
  nation?: string;
  /**
   * 出生年月
   */
  birthday: string;
  /**
   * 现工作单位及职务
   */
  job?: string;
}

// tslint:disable-next-line:no-empty-interface
export enum Sex {
  男 = 1,
  女 = 2,
}

export interface ImportProvinceCadreTrainRecordDto {
  /**
   * 姓名
   */
  name: string;
  /**
   * 性别
   */
  sex?: string;
  /**
   * 民族
   */
  nation?: string;
  /**
   * 出生年月
   */
  birthday: string;
  /**
   * 当前工作单位及职务
   */
  currentJob?: string;
  /**
   * 培训时工作单位及职务
   */
  job: string;
  /**
   * 培训班名称
   */
  className: string;
  /**
   * 培训机构类型
   */
  orgType?: string;
  /**
   * 培训机构
   */
  organization?: string;
  /**
   * 培训开始时间
   */
  startDate: string;
  /**
   * 培训截止时间
   */
  endDate?: string;
  /**
   * 班次类别：培训班、研修班、专题班
   */
  classCategory?: string;
  /**
   * 培训内容类型 政治理论、党性教育、专业化能力、综合业务、其他
   */
  trainType?: string;
  /**
   * 备注
   */
  remarks?: string;

  account?: string;
  /**
   * 区管干部id
   */
  provinceCadreId?: string;

  id?: string;
}

export interface UpdateTraineeInfoDto {
  /**
   * 学员Id
   */
  traineeId: string;
  /**
   * 培训记录Id
   */
  trainRecordId: string;
  /**
   * 姓名
   */
  name: string;
  /**
   * 工作单位
   */
  workUnit: string;
  /**
   * 职务
   */
  job: string;
}

// tslint:disable-next-line:no-empty-interface
export enum Comparator {
  大于等于 = 0,
  大于 = 1,
  等于 = 2,
  不等于 = 3,
  小于等于 = 4,
  小于 = 5,
}

export interface ClassSigninDto {
  userId?: string;
  /**
   * 培训班id
   */
  classId: string;
  /**
   * 培训班类型
   */
  classType: TrainingClassType;
}

export interface TrainRecordDto extends TrainRecordBaseDto {
  publicTrainingClassId?: string;

  traineeId?: string;

  deptId: string;

  name: string;

  phone: string;

  job?: string;

  workUnit?: string;
}

export interface TrainRecordBaseDto {
  type: TrainRecordType;

  className: string;

  trainType?: string;

  locationCategory?: string;

  runClassType?: string;

  content?: string;

  province?: string;

  city?: string;

  county?: string;

  address?: string;

  startDate: string;

  endDate: string;

  days: number;

  trainingLevel?: TrainingClassLevel;

  organization?: string;

  sponsor?: string;

  teacher?: string;

  teacherUnit?: string;

  teacherPost?: string;

  teacherPhone?: string;

  certificate?: string;

  lostProof?: string;

  id?: string;
}

// tslint:disable-next-line:no-empty-interface
export enum TrainRecordType {
  线下 = 0,
  线上 = 1,
  党委党组中心组学习 = 2,
}

// tslint:disable-next-line:no-empty-interface
export enum TrainingClassLevel {
  中组部调训班次 = 1,
  自治区党委组织部调训班次 = 2,
  其他班次 = 3,
}

export interface TrainingLevelTree {
  code?: string;

  value?: string;

  organizations?: string[];

  children?: TrainingLevelTree[];
}

export interface AddRecordToStudent extends ImportTrainStudentDto {
  /**
   * 培训班类型
   */
  classType: TrainingClassType;
  /**
   * 培训班Id
   */
  publicTrainingClassId: string;
}

export interface ImportTrainStudentDto {
  /**
   * 姓名
   */
  name: string;
  /**
   * 单位
   */
  workUnit: string;
  /**
   * 职务
   */
  job: string;
  /**
   * 手机号
   */
  phone: string;
  /**
   * 学员id
   */
  traineeId?: string;
}

export interface ApiResponseData<T> {
  /**
   * 操作是否成功
   */
  success: boolean;

  /**
   * 状态码
   */
  statusCode: number;

  /**
   * 时间
   */
  time: any;

  /**
   * 提示信息
   */
  message: string;

  /**
   * 操作结果数据
   */
  data?: T;
}

/**
 * Non-enumerable version of the IPagedList class.
 */
export interface IPagedList<T> {
  /**
   * 总页数
   */
  pageCount: number;
  /**
   * 元素总个数
   */
  totalItemCount: number;
  /**
   * 元素总个数
   */
  pageNumber: number;
  /**
   * 每页大小
   */
  pageSize: number;
  /**
   * 是否有上页
   */
  hasPreviousPage: boolean;
  /**
   * 是否有下页
   */
  hasNextPage: boolean;
  /**
   * 是否首页
   */
  isFirstPage: boolean;
  /**
   * 是否末页
   */
  isLastPage: boolean;
  /**
   * 当前页第一个元素在总列表中的序号，从0开始
   */
  firstItemOnPage: number;
  /**
   * 当前页最后一个元素在总列表中的序号，从0开始
   */
  lastItemOnPage: number;

  /**
   * 元素列表
   */
  items?: T[];
}

/** 树节点 */
export interface TreeNode<T> {
  /** id or code */
  key: string;

  /** 父节点ID or code */
  parentKey: string;

  /** display name */
  title: string;

  /** value */
  value: string;

  /** 子节点 */
  children: TreeNode<T> | undefined | any;

  /** 数据项 */
  data: T | undefined | any;

  /** 插槽 */
  slots: any;
}

/** ConfiguredList */
export interface ConfiguredList<T> {}
